import request from '@/service/request'

export default {
  ...request,
  // base_url: 'http://localhost:5000/',
  base_url: 'https://api-huaydragon.com/lotto/',
  getURL() {
    return this.base_url
  },
}
